/* GENERATED from storefront-cart-min.src.js by build/gen_js.py - do not edit.
   The commented source is storefront-cart-min.src.js. */
(function () {
'use strict';
function min(el) {
var item = el.closest && el.closest('[data-min-qty]');
return item ? { item: item, n: +item.getAttribute('data-min-qty') || 0 } : null;
}
document.addEventListener('click', function (e) {
var b = e.target.closest && e.target.closest('[data-cart-minus]');
var m = b && min(b);
if (!m) return;
var input = m.item.querySelector('[data-cart-qty]');
if ((+input.value || 0) - 1 < m.n) {
e.stopImmediatePropagation();
e.preventDefault();
}
}, true);
document.addEventListener('change', function (e) {
var m = e.target.matches && e.target.matches('[data-cart-qty]') && min(e.target);
if (!m) return;
var v = +e.target.value || 0;
if (v > 0 && v < m.n) e.target.value = m.n;
}, true);
})();
